<div id="plate-search-container">
  <mat-form-field appearance="outline">
    <mat-label>Targa</mat-label>
    <input matInput [(ngModel)]="vehiclePlateToSearch" (ngModelChange)="vehiclePlateToSearch = $event.toUpperCase()" #plateInput>
  </mat-form-field>
  <!--div class="input">
    <input type="text" class="form-control" #plateInput>
  </div-->

  <button mat-button color="primary" (click)="searchVehicleByPlate()" [disabled]="plateInput.value.length < 3">Cerca</button>
</div>
